module.exports = __webpack_public_path__ + "img/UA.9a8f121d.svg";